import { render, staticRenderFns } from "./OnboardingQuestionIndex.vue?vue&type=template&id=295def0c&scoped=true&"
import script from "./OnboardingQuestionIndex.vue?vue&type=script&lang=js&"
export * from "./OnboardingQuestionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295def0c",
  null
  
)

export default component.exports